/* Loan period units, shortest first. A repayment cannot fall due less often
   than the loan lasts (an 8-month loan repaid yearly is no loan), and a grace
   period cannot outlast a repayment cycle. So each unit select further down
   that chain - Loan Term, then Repayment Frequency, then Grace Period -
   offers no unit longer than the one before it, the rule the original loan
   product form enforced. */
const PERIOD_ORDER = ['DAY', 'WEEK', 'MONTH', 'YEAR'];

const rank = (unit: string): number =>
  PERIOD_ORDER.indexOf(String(unit ?? '').toUpperCase());

/**
 * The options no longer than `limit`, or all of them when the limit is not a
 * known unit. `keep` stays in the list even when longer, so a saved value
 * that breaks the rule still shows rather than leaving the select blank.
 */
export function unitsUpTo<T extends { value: string }>(
  options: T[],
  limit: string,
  keep?: string,
): T[] {
  const max = rank(limit);
  if (max < 0) return options;
  return options.filter(
    (option) => rank(option.value) <= max || option.value === keep,
  );
}

/** `unit` moved down to `limit` when it is longer; otherwise unchanged */
export function clampUnit(unit: string, limit: string): string {
  const max = rank(limit);
  return max >= 0 && rank(unit) > max ? limit : unit;
}
